import { CirclePlus, CircleX, X } from "lucide-react";
import React from "react";

import { CircularProgress, IconButton, useTheme } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton/IconButton";

import { IgCustomTheme } from "./theme";

export interface IgIconButtonProps extends Omit<IconButtonProps, "color"> {
  loading?: boolean;
  iconType?: "add" | "clear" | "close";
  iconSize?: number;
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success";
}

export const IgIconButton = (props: IgIconButtonProps) => {
  const theme = useTheme<IgCustomTheme>();
  const { children, onClick, loading, iconType, sx, iconSize, color, ...rest } =
    props;

  const colorMap = {
    primary: theme.igIconColors.light,
    secondary: theme.igIconColors.dark,
    error: theme.igIconColors.error,
    warning: theme.igIconColors.warning,
    info: theme.igIconColors.info,
    success: theme.igIconColors.success,
  };

  const iconColor = color ? colorMap[color] : colorMap["primary"];

  const IconButtonChild = loading ? (
    <CircularProgress size={23} />
  ) : iconType && iconType === "add" ? (
    <CirclePlus size={iconSize ?? 22} color={iconColor} />
  ) : iconType && iconType === "clear" ? (
    <CircleX size={iconSize ?? 22} color={iconColor} />
  ) : iconType && iconType === "close" ? (
    <X className={props.className} size={iconSize ?? 22} color={iconColor} />
  ) : (
    children
  );

  return (
    <IconButton
      {...rest}
      sx={sx}
      color={color}
      onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
    >
      {IconButtonChild}
    </IconButton>
  );
};
